import axios from 'axios';
import { AsyncAction } from '..';
import { DamageMechanismDescriptor } from '../../types/plan';

type State = {
    fetching: boolean;
    items: { [code: number]: DamageMechanismDescriptor };
    error?: Error;
};

type Action = {
    type: 'plan_damageMechanism/get';
    payload?: { items: { [code: number]: DamageMechanismDescriptor } };
    error?: Error;
};

const initialState: State = {
    fetching: false,
    items: {},
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'plan_damageMechanism/get':
            if (action.payload) return { ...state, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        default:
            return state;
    }
};

/**
 * Request all asset damage mechanisms from the server.
 * 
  @param rethrow throw the internal error, causing the promise generated by the dispatch to fail
 */
const get = (rethrow = false): AsyncAction => async dispatch => {
    try {
        dispatch({ type: 'plan_damageMechanism/get' });
        const cancel = axios.CancelToken.source();
        dispatch({ type: 'cancel/set', payload: { 'plan_damageMechanism/get': cancel } });
        const response = await axios.get<DamageMechanismDescriptor[]>('/damage-mechanism-descriptors/', {
            cancelToken: cancel.token,
        });
        const items = response.data.reduce<State['items']>((acc, dm) => ((acc[dm.code] = dm), acc), {});
        dispatch({ type: 'plan_damageMechanism/get', payload: { items } });
    } catch (error) {
        dispatch({ type: 'plan_damageMechanism/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
